import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from '@iconify/react'
import './style.css'
import { generator } from '@/utils/NumbersUtils'
import { Block } from '@/components/crRender'

const FileUploadField = ({
    formHandler,
    name,
    label,
    id,
    accept = "*/*",
    multiple = false,
    maxFiles = 1,
    helperText
}) => {



    const { t } = useTranslation()
    const [selectedFiles, setSelectedFiles] = useState([])

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files)

        if (files.length > maxFiles) {
            alert(t('max-files-exceeded', { max: maxFiles }))
            return
        }
        setSelectedFiles(files)
        if (formHandler) {
            formHandler(name, files)
        }
    }

    const handledIcon = (file) => {
        if (file.type.includes('image')) {
            return {icon: 'lets-icons:img-box-duotone', className: 'image-icon'}
        } else if (file.type.includes('video')) {
            return {icon: 'streamline-flex:camera-video-solid', className: 'video-icon'}
        } else if (file.type.includes('audio')) {
            return {icon: 'lucide:audio-lines', className: 'audio-icon'}
        } else if (file.type.includes('pdf')) {
            return {icon: 'material-icon-theme:pdf', className: 'pdf-icon'}
        } else {
            return {icon: 'codex:file', className: 'file-icon'}
        }
    }
    return (
        <div className="file-upload-field">
            <Block isRender={!!label}>
                <label className="file-upload-label">{label}</label>
            </Block>

            <div className="file-upload-area">
                <input
                    type="file"
                    id={id || `file-${name}`}
                    accept={accept}
                    multiple={multiple}
                    onChange={handleFileChange}
                    className="file-input-hidden"
                />

                <label htmlFor={id || `file-${name}`} className="file-upload-button">
                    <Icon icon="mdi:cloud-upload" className="upload-icon" />
                    <span>{t('click-to-upload')}</span>
                </label>

                {selectedFiles.length > 0 && (
                    <div className="selected-files">
                        <p className="files-count">
                            {selectedFiles.length} {t('file-selected', { count: selectedFiles.length })}
                        </p>
                        <ul className="files-list">
                            {selectedFiles.map((file, index) => (
                                <li key={file.key} className="file-item">
                                    <Icon icon={handledIcon(file).icon} className={handledIcon(file).className} />
                                    <span>{file.name}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>

            {helperText && <p className="helper-text">{helperText}</p>}
        </div>
    )
}

export default FileUploadField

